<div class="flex flex-col w-full bg-white rounded-2xl overflow-hidden">
    <!-- Header -->
    <div class="flex justify-between items-center px-6 py-5 border-b border-gray-200">
        <div class="flex items-center gap-3">
            <div class="p-2 rounded-lg bg-orange-100">
                <mat-icon svgIcon="mat_outline:warning" class="icon-size-6 text-orange-600"></mat-icon>
            </div>
            <h2 class="text-[18px] font-semibold font-inter text-gray-900 m-0">{{ data.title }}</h2>
        </div>
        <button
            mat-icon-button
            (click)="onCancel()"
            class="w-9 h-9 text-gray-500 hover:bg-gray-100 hover:text-gray-900 transition-all duration-200">
            <mat-icon class="icon-size-6" [svgIcon]="'mat_outline:close'"></mat-icon>
        </button>
    </div>

    <!-- Content -->
    <div class="p-6">
        <p class="text-[14px] font-inter text-gray-700 leading-relaxed">
            {{ data.message }}
        </p>
    </div>

    <!-- Footer -->
    <div class="flex items-center justify-end gap-3 px-6 py-4 border-t border-gray-200 bg-gray-50">
        <button
            mat-stroked-button
            (click)="onCancel()"
            class="rounded-3xl px-6 py-2 border border-gray-300 font-inter text-[14px] font-[400]">
            {{ data.cancelButtonText || 'Não' }}
        </button>
        <button
            mat-flat-button
            (click)="onConfirm()"
            class="rounded-3xl px-6 py-2 bg-[#0061ff] hover:bg-[#2f75e7] text-white font-inter text-[14px] font-[400]">
            {{ data.confirmButtonText || 'Sim' }}
        </button>
    </div>
</div>
